import { render, staticRenderFns } from "./OFormGroup.vue?vue&type=template&id=647c5e23&scoped=true&"
import script from "./OFormGroup.vue?vue&type=script&lang=js&"
export * from "./OFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./OFormGroup.vue?vue&type=style&index=0&id=647c5e23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c5e23",
  null
  
)

export default component.exports